import Vue from 'vue';
import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

export default {
  actions: {
    async [actions.DO_CREATE_FORM_FIELD]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.post(`/form_blocks/${id}/form_fields`, params);
      return data;
    },
    async [actions.DO_GET_FORM_FIELD]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.get(`/form_fields/${id}`, { params });
      commit(mutations.SET_FORM_FIELD, data.data.form_fields[0]);
      return data;
    },
    async [actions.DO_OVERRIDE_FORM_FIELD]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.put(`/form_fields/${id}`, params);
      return data;
    },
    async [actions.DO_UPDATE_FORM_FIELD]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.patch(`/form_fields/${id}`, params);
      return data;
    },
    async [actions.DO_DELETE_FORM_FIELD]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.delete(`/form_fields/${id}`, params);
      return data;
    },
  },
  getters: {
    [getters.GET_FORM_FIELD]: state => state.field,
  },
  mutations: {
    [mutations.SET_FORM_FIELD](state, field) {
      state.field = field;
    },
    [mutations.SET_FORM_FIELD_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.field;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
  },
  state: {
    field: {},
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/form_field.js